import { system } from './system';

// K12 uses the base spacing and text styles, so it shares the base system rather than building an identical one.
export const k12 = system;
